import { useState, useEffect } from 'react';
import { useCases } from '../../core/di/useCases';
// eslint-disable-next-line no-unused-vars -- Used in JSDoc
import { Category } from '../../domain/category/entities/Category';

/**
 * Hook pour récupérer la liste des catégories d'activités
 * @returns {{ 
 *   categories: Array<Category>,
 *   loading: boolean, 
 *   error: Error | null 
 * }}
 */
export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const result = await useCases.listCategories.execute();
        setCategories(result);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return { categories, loading, error };
}; 